import { PanelItemGroup } from '../panel-item-group.class';

export const widthRangeCfn = (panelItemGroup: PanelItemGroup, outside = false): [number, number] => {
	let min: number = null;
	let max = 0;

	panelItemGroup.items.children.forEach((i) => {
		const baseWidth = outside ? i.item.component.size.width : i.item.component.cutout.width;
		const baseDepth = outside ? i.item.component.size.depth : i.item.component.cutout.depth;

		// For rotated items, compute the bounding box width
		const { z: irZ } = i.instanceRotation;
		const effectiveWidth = irZ !== 0
			? Math.abs(baseWidth * Math.cos(irZ)) + Math.abs(baseDepth * Math.sin(irZ))
			: baseWidth;

		max = Math.max(max, effectiveWidth);
		min = min === null ? max : Math.min(min, effectiveWidth);
	});

	return [min, max];
};
